class InViewService {
  items = {};

  createScrollListener() {
    window.addEventListener('scroll', (e) => this.onScroll());
  }

  add({ id, onScroll, element }) {
    this.items[id] = {
      onScroll,
      element,
    };
    // allows "true" to register onProps for components
    this.items[id].onScroll(false);
  }

  remove(id) {
    delete this.items[id];
  }

  onScroll(e) {
    for (const id of Object.keys(this.items)) {
      const el = this.items[id].element;
      const pos = getPosition(el);
      const height = el.offsetHeight;
      const winHeight = window.innerHeight;
      const isShowing = pos + height < winHeight && pos > -height;

      this.items[id].onScroll(isShowing);
    }
  }
}

const getPosition = (el) => {
  let yPos = 0;

  while (el) {
    if (el.tagName == 'BODY') {
      const yScroll = el.scrollTop || document.documentElement.scrollTop;

      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent;
  }
  return yPos;
}

export const inViewService = new InViewService();
